module.exports = __webpack_public_path__ + "static/logo-9dcedef1aff314fb309da26f381a2abf.png";